module.exports = __webpack_public_path__ + "static/journal-altin-rose-e1072b44483374481a55ae80d60c5619.mp3";